export function formatMotora(values) {
    return {
        idMotorista: values.idMotorista,
        nome: values.nome,
        telefone: values.telefone,
        nomeEmergencia: values.nomeEmergencia,
        telefoneEmergencia: values.telefoneEmergencia,
        numeroDocumento: values.numeroDocumento,
        tipoDocumento: values.tipoDocumento,
        frota: values.frota,
        motivo: values.motivo ?? "",
        bloqueado: values.bloqueado ?? false,
        rg: values.rg,
        endereco: {
            bairro: values.bairro,
            rua: values.rua,
            numero: parseInt(values.numero),
            complemento: values.complemento ?? "",
            cep: values.cep,
            cidade: values.cidade,
            latitude: values.latitude,
            longitude: values.longitude
        },
    }
}

export const colunasMotorista = [
    {
        'nomeColuna': 'Nome Motorista',
        'field': 'nome'
    },
    {
        'nomeColuna': 'Número Documento',
        'field': 'numeroDocumento'
    },
    {
        'nomeColuna': 'Tipo Documento',
        'field': 'tipoDocumento'
    },
    {
        'nomeColuna': 'Telefone',
        'field': 'telefone'
    },
    {
        'nomeColuna': 'Pessoa Emergência',
        'field': 'nomeEmergencia'
    },
    {
        'nomeColuna': 'Telefone Emergência',
        'field': 'telefoneEmergencia'
    },
    {
        'nomeColuna': 'Endereço',
        'field': 'endereco',
        'objetoEndereco': 'true',
    },
    {
        'nomeColuna': 'Frota',
        'field': 'frota'
    },
    {
        'nomeColuna': 'Usuário',
        'field': 'usuario',
        'objetoUsuarios': 'true'
    },
    {
        'nomeColuna': 'Bloqueado',
        'field': 'bloqueado'
    },
    {
        'nomeColuna': 'Motivo',
        'field': 'motivo'
    },
];